import {useEffect} from 'react';
import {stringifyUrl} from 'query-string';

const useUnsplashBeacons = (images: PlaceImage[]) => {
  const unsplashIds = images.map((im) => im.unsplashId).filter(Boolean);

  useEffect(() => {
    if (!unsplashIds.length) return;

    const url = stringifyUrl({
      url: 'https://views.unsplash.com/v',
      query: {
        app_id: process.env.NEXT_PUBLIC_UNSPLASH_APP_ID,
        photo_id: unsplashIds.join(',')
      }
    });

    fetch(url);
  }, [JSON.stringify(unsplashIds)]);
};

export default useUnsplashBeacons;
